import React from 'react';
import PropTypes from 'prop-types';
import "./rscard.css"
import CurrencyFormat from 'react-currency-format';

const RsCardImgv5  = ({ title, description, iconClass, userdetail }) => {
  return (
  <div className="card rs-card-v4 bg-v2 rs-card-compact">
  <div className="card-body py-2 px-3">
    <div className="d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center gap-5">
            
             <div className='titleText'>
               <h3> {title}</h3>
            </div>
              <div className='titleDesc'>
                            <h3>
                                {title === "Cost per lead" ? (
                               <CurrencyFormat
                                 value={description}
                                 displayType={'text'}
                                 thousandSeparator={true}
                                 prefix={'$'}
                               />
                             ) : title === "Cost per client" ? (
                                <CurrencyFormat
                                 value={description}
                                 displayType={'text'}
                                 thousandSeparator={true}
                                 prefix={'$'}
                               />
                             ) : (
                               description
                             )}
                </h3>
            </div>
    </div>
    </div>
  </div>
</div>

  );
};

RsCardImgv5.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  iconClass: PropTypes.string,
  userdetail: PropTypes.object,
};

RsCardImgv5.defaultProps = {
  title: 'Default Title',
  description: 'Default Description',
  iconClass: 'bx-default-icon',
};

export default RsCardImgv5;